import { useLocation } from 'react-router-dom';
import { createRouteMapping } from '../config/navigation';

export const usePageName = (): string => {
    const location = useLocation();
    const routeMapping = createRouteMapping();

    const getPageName = (pathname: string): string => {
        const match = pathname.match(/\/c\/[^/]+\/(.+)/);
        const route = match ? `/${match[1].split('/')[0]}` : pathname;

        return routeMapping[route];
    };

    return getPageName(location.pathname);
};
